import AdminPage from './admin';

export default AdminPage;
